import React from 'react';

export default function SidePanelFrame({ side = 'left' }) {
  const sideClass = side === 'left' ? 'left-0' : 'right-0';
  const gradientClass =
    side === 'left'
      ? 'bg-gradient-to-r from-white/45 via-white/20 to-transparent'
      : 'bg-gradient-to-l from-white/45 via-white/20 to-transparent';

  return (
    <div aria-hidden className={`pointer-events-none absolute inset-y-8 ${sideClass} w-8 md:w-14`}>
      <div className={`h-full rounded-2xl border border-white/35 ${gradientClass}`} />
    </div>
  );
}
